/**
 * @author: Angel Labrada Massó
 * @since v0.0.1
 * @date 8/5/22
 */
import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Card, Row, Col} from 'antd';
import {Select } from 'antd';
import {useTranslation} from 'react-i18next';
import styles from './index.less';

const {Option} = Select;

const PreviewSelectType = ({parameter}) => {
  const {t} = useTranslation('templates');

  /** Get Options if parameter fieldType is select */
  const getOptions = useMemo(() => {
    if (parameter?.parameter?.selectOption)
      return parameter?.parameter?.selectOption?.split(',');
    return [];
  }, [parameter]);

  return (
    <Card className={styles.card}>
      <Row gutter={[16,16]} className="flex items-center justify-center">
        <Col span={6}>{parameter?.parameter?.name || parameter?.parameter?.label}</Col>
        <Col span={18}>
          <Select
            className="w-full custom-select"
            showSearch
            placeholder={t('placeholderSelectOptions')}
          >
            {
              parameter?.parameter?.fieldType === 'select' && parameter?.parameter?.type !== 'field'
                ? getOptions?.map((item, idx) => (
                  <Option key={idx} value={t(item)}>{t(item)}</Option>
                ))
                : parameter?.select?.options?.map((item) => (
                  <Option key={item?._id} value={t(item?.label || item?.name)}>{t(item?.label || item?.name)}</Option>
                ))
            }
          </Select>
        </Col>
      </Row>
    </Card>
  );
};

PreviewSelectType.propTypes = {
  parameter: PropTypes.object
};

export default memo(PreviewSelectType);
